import {
  SheetHeader,
  SheetTitle,
  usePreventSheetClose,
} from "@/components/ui/sheet";
import { UseFormReturn } from "react-hook-form";
import { ExpenseFormValues } from "../forms/Forms";
import { ReimbursementDetailsForm } from "./ReimbursementDetailsForm";
import { SheetBackButton } from "@common/components/SheetActions/SheetBackButton";
import { useRef, useState } from "react";
import { SelectFromHypercardContent } from "./SelectFromHypercardContent";
import {
  SheetTabsContainer,
  SheetTabsContent,
  SheetTabsList,
} from "@common/components";
import { mergeExpenseFormValues } from "@common/utils";
import { hasDirtyFields } from "@/utils/utils";

const SheetTabs = [
  {
    name: "Manual",
    value: "manual",
  },
  {
    name: "Select from Hypercard",
    value: "select-from-hypercard",
  },
];

interface Props {
  form: UseFormReturn<ExpenseFormValues>;
  nextStep: () => void;
  onCloseView?: () => void;
  submitText?: string;
  loading?: boolean;
}

export const ReimbursementDetailsContent = ({
  form,
  nextStep,
  onCloseView,
  submitText,
  loading,
}: Props) => {
  const [tab, setTab] = useState("manual");
  const didPrefillWithOcr = useRef(false);

  usePreventSheetClose(() => hasDirtyFields(form) || didPrefillWithOcr.current);

  const handlePrefillForm = (formValues: Partial<ExpenseFormValues>) => {
    didPrefillWithOcr.current = true;
    form.reset(mergeExpenseFormValues(form.getValues(), formValues));
    setTab("manual");
  };

  return (
    <>
      {onCloseView && <SheetBackButton onClick={onCloseView} />}
      <SheetHeader>
        <SheetTitle>Create Reimbursement</SheetTitle>
      </SheetHeader>
      <SheetTabsContainer value={tab} onValueChange={setTab}>
        <SheetTabsList tabs={SheetTabs} />
        <SheetTabsContent value="manual">
          <ReimbursementDetailsForm
            form={form}
            onSubmit={nextStep}
            submitText={submitText}
            loading={loading}
            onParseReceipt={handlePrefillForm}
          />
        </SheetTabsContent>
        <SheetTabsContent value="select-from-hypercard">
          <SelectFromHypercardContent onSelection={handlePrefillForm} />
        </SheetTabsContent>
      </SheetTabsContainer>
    </>
  );
};
